module.exports = __webpack_public_path__ + "static/other/warehouse_game.7554bb33.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/warehouse_game.json
// module id = 2398
// module chunks = 0